<div class="container">

  <div class="text-center mb-4">
    <div class="custom-icon mb-3">
      <svg width="40" height="55" viewBox="0 0 40 55" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="20.0318" cy="30.4677" r="17.6392" fill="#FDDBE3" />
        <path
          d="M11.4958 9.14199C11.4958 8.71678 11.6021 8.39788 11.921 8.07897C12.1867 7.81321 12.5588 7.65376 12.9308 7.70691C14.047 7.86637 16.4388 8.34473 18.2991 10.205C19.9999 11.9059 19.9999 12.7563 19.9999 12.7563C19.9999 12.7563 19.9999 11.9059 21.7008 10.205C23.5611 8.34473 25.9529 7.86637 27.0691 7.70691C27.4411 7.65376 27.8132 7.81321 28.0789 8.07897C28.3978 8.39788 28.5041 8.71678 28.5041 9.14199C28.3978 10.205 27.9195 12.4905 26.3781 14.0319C24.252 16.1579 22.6044 16.2111 19.9999 16.1579C17.3955 16.2111 15.7479 16.1579 13.6218 14.0319C12.0804 12.4905 11.6021 10.205 11.4958 9.14199Z"
          fill="#98B899" />
        <path
          d="M12.984 21.473C16.8641 17.593 23.1359 17.593 27.016 21.473C29.7267 24.1838 30.6302 28.2764 29.2483 31.8907L26.3781 39.6507H20C19.3622 39.6507 18.7775 40.2354 18.7775 40.8732C18.7775 41.511 19.3622 42.0957 20 42.0957H25.5277L21.7008 52.5133C21.3819 53.2574 20.7973 53.7358 20 53.6826C19.2027 53.7358 18.5649 53.2043 18.2992 52.5133L10.7517 31.8907L10.6985 31.8375L16.5983 31.8907C17.2893 31.8375 17.8208 31.306 17.8208 30.6682C17.8208 30.0304 17.2361 29.4457 16.5983 29.4457L10.167 29.4989C9.90128 26.5756 10.858 23.5991 12.984 21.473Z"
          fill="#F48C4C" />
      </svg>
    </div>
    <h1 class="h2-semibold">Almost neighbors…</h1>
    <h1 class="h2-regular">but not quite (yet)!</h1>
  </div>

  <div class="row">
    <div class="col mb-3">
      <p class="text-center d-block h6-regular">
        We don’t deliver to your address right now, but we’re expanding all the time. Leave your email and we’ll let you know the second we reach your street.
      </p>
    </div>
  </div>

  <form class="needs-validation">
    <div class="row mt-4 pb-2 row-gap-3">
      <div [class.col-lg-6]="!computedZipCode()" [class.col-lg-3]="computedZipCode()" class="col-md-12">
        <div class="form-floating has-validation">
          <input type="text" class="form-control" placeholder name="firstName"
            [class.is-invalid]="!prospectInformationValidations.get('firstName')?.()?.valid"
            [ngModel]="prospectForm()?.firstName"
            (ngModelChange)="updateProspectForm({firstName: $event }, 'firstName')">
          <label for="firstName">First Name</label>
          @if (!prospectInformationValidations.get('firstName')?.()?.valid) {
          <div class="invalid-feedback">
            <i class="fas fa-xmark"></i>
            {{ prospectInformationValidations.get('firstName')?.()?.error }}
          </div>
          }
        </div>
      </div>
      <div [class.col-lg-6]="!computedZipCode()" [class.col-lg-3]="computedZipCode()" class="col-md-12">
        <div class="form-floating has-validation">
          <input type="text" class="form-control" placeholder name="lastName"
            [class.is-invalid]="!prospectInformationValidations.get('lastName')?.()?.valid"
            [ngModel]="prospectForm()?.lastName" (ngModelChange)="updateProspectForm({lastName: $event }, 'lastName')">
          <label for="lastName">Last Name</label>
          @if (!prospectInformationValidations.get('lastName')?.()?.valid) {
          <div class="invalid-feedback">
            <i class="fas fa-xmark"></i>
            {{ prospectInformationValidations.get('lastName')?.()?.error }}
          </div>
          }
        </div>
      </div>
      <div [class.col-lg-8]="!computedZipCode()" [class.col-lg-6]="computedZipCode()" class="col-md-12">
        <div class="form-floating has-validation">
          <input type="email" class="form-control" placeholder name="email"
            [class.is-invalid]="!prospectInformationValidations.get('email')?.()?.valid"
            [ngModel]="prospectForm()?.email" (ngModelChange)="updateProspectForm({email: $event }, 'email')">
          <label for="email">Email</label>
          @if (!prospectInformationValidations.get('email')?.()?.valid) {
          <div class="invalid-feedback">
            <i class="fas fa-xmark"></i>
            {{ prospectInformationValidations.get('email')?.()?.error }}
          </div>
          }
        </div>
      </div>
      @if(!computedZipCode()){
      <div class="col-lg-4 col-md-12">
        <div class="form-floating has-validation">
          <input type="text" maxlength="5" class="form-control" placeholder name="zipCode" appOnlyNumber
            [class.is-invalid]="!prospectInformationValidations.get('zipCode')?.()?.valid"
            [ngModel]="prospectForm()?.zipCode" (ngModelChange)="updateProspectForm({zipCode: $event }, 'zipCode')">
          <label for="zipCode">Zip code</label>
          @if (!prospectInformationValidations.get('zipCode')?.()?.valid) {
          <div class="invalid-feedback">
            <i class="fas fa-xmark"></i>
            {{ prospectInformationValidations.get('zipCode')?.()?.error }}
          </div>
          }
        </div>
      </div>
      }
    </div>
  </form>

  <div class="row justify-content-md-center my-4 row-gap-3">
    <div class="col-lg-4 col-md-12">
      <button type="button" class="btn btn-primary w-100" [disabled]="!isValidFormProspectInformation()"
        (click)="addProspect()">
        Share my information
      </button>
    </div>
    <div class="col-lg-4 col-md-12">
      <button type="button" class="btn btn-outline-primary w-100" (click)="activeModal.close(false)">
        Try another address
      </button>
    </div>
  </div>
</div>